import { gsap } from 'gsap';
function Animate(
  sprite,
  { duration = 0.5, speed = 1, ease = 'Cubic.easeIn', canvasHeight, canvasWidth, index, totalLines, istemplate }
) {
  //var height = sprite.height;
  //var width = sprite.width;
  if (totalLines) {
    var spriteHeight = sprite.height;
    var spriteWidht = sprite.width;
    var centerY = (totalLines * sprite.height) / 2;
    var firstLineY = sprite.y - index * spriteHeight;
    var x = sprite.x;
    var y = sprite.y;
    sprite.scale.x = 0;
    sprite.scale.y = 0;
    sprite.x = x + spriteWidht / 2;
    sprite.y = firstLineY + centerY;
    let delay = 0;
    if (istemplate && index && index > 0) {
      delay = index * (duration * speed);
    }
    var animation = gsap.to(sprite, {
      pixi: { scale: 1, x: x, y: y },
      duration: speed,
      ease: 'power3.out',
      paused: true,
      delay: delay,
    });
    return animation;
  } else {
    var spriteHeight = sprite.height;
    var spriteWidht = sprite.width;
    var x = sprite.x;
    var y = sprite.y;
    sprite.width = 0;
    sprite.height = 0;
    sprite.x = canvasWidth / 2;
    sprite.y = canvasHeight / 2;
    let delay = 0;
    if (istemplate && index && index > 0) {
      delay = index * (duration * speed);
    }
    var animation = gsap.to(sprite, {
      pixi: { x: x, y: y, width: spriteWidht, height: spriteHeight },
      duration: speed,
      ease: 'power3.out',
      paused: true,
      delay: delay,
    });
    return animation;
  }
}
export default { Animate };
